import * as R from 'ramda';

const pathIsTruthy = R.curry((path, data) => R.compose(Boolean, R.path(path))(data));

export default pathIsTruthy;
